import React from 'react';

import { BaseIconProps } from './';

export const Map = ({ fill }: BaseIconProps) => (
  <path
    fill={fill}
    d="M 961.43792,148.24179 V 860.08675 L 736.6244,931.64296 V 219.79801 Z m -533.80627,0 224.73608,71.55622 V 931.64296 L 427.63165,860.08675 Z m -84.33411,0 V 860.08675 L 118.56146,931.64296 V 219.79801 Z M 372.72542,50.355377 63.732669,148.70645 a 43.367403,43.367403 0 0 0 -29.427881,40.34717 v 800.51582 c 0.07744,26.33016 29.737649,47.93646 54.828792,39.95996 l 296.2923,-94.40156 296.36973,94.47896 a 42.592986,42.592986 0 0 0 25.47835,0 l 308.99274,-98.35105 a 43.367403,43.367403 0 0 0 29.4279,-39.95996 V 90.70255 C 1045.8495,64.2949 1016.0344,42.378873 990.86579,50.355377 L 694.49606,144.75691 398.20377,50.277936 a 45.148565,45.148565 0 0 0 -25.47835,0 z"
    strokeWidth={77.4418}
  />
);
